export const NavigationLocked = Object.freeze({
	NONE: { text: 'None (Free)', value: false },
	SEQUENTIAL: { text: 'Sequential', value: 'sequential' }
});

const navigationOptions = [
	NavigationLocked.NONE,
	NavigationLocked.SEQUENTIAL
]

export default navigationOptions